import { createSlice } from "@reduxjs/toolkit";
//import { sampleMenu } from "../../Entities/RestaurantMenu";
const initialState = {
  //restaurantInfo : sampleMenu.data.restaurant_info,
  categories : [],
  //menu_items : sampleMenu.data.menu_items,
  status: "idle",  
  error: null,
};
const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories: (state, action) => {
      const { categories } = action.payload;
      //state.restaurantInfo = restaurantInfo;
      state.categories = categories;
      //state.menu_items = menu_items;
      state.status = "succeeded";
      state.error = null;
    },
     setError(state, action) {
    state.error = action.payload;
    state.status = "failed";
  },
    clearCategories: (state) => {
      //state.categories = null;
      state.categories = [];
      //state.menu_items = [];
      state.status = "idle";
      state.error = null;
    },
    updateCategoryInfo: (state, action) => {
      const { category_id, category_name } = action.payload;
      if (!state.categories) return;
      for (const rest of state.categories) {
        const item = rest.items.find((i) => i.category_id === category_id);
        if (item) {
          item.category_name = category_name;
          break;
        }
      }
    },
  },
});

export const { setCategories,setError,clearCategories, updateCategoryInfo } = categorySlice.actions;
export default categorySlice.reducer;